import { Outlet, Navigate } from "react-router-dom";
import { ShieldCheck, Building2, Users, BrickWallFire } from "lucide-react";
import SettingsSectionNav from "../../components/Settings/SettingsSectionNav";
import ROUTES from "../../router/routes";

const IDENTITY_NAV = [
  { path: ROUTES.SETTINGS.IDENTITY_SSO,         label: "SSO Providers",     icon: ShieldCheck },
  { path: ROUTES.SETTINGS.IDENTITY_DIRECTORY,   label: "Google Workspace",  icon: Building2   },
  { path: ROUTES.SETTINGS.IDENTITY_SCIM,        label: "SCIM Provisioning", icon: Users       },
  { path: ROUTES.SETTINGS.IDENTITY_BREAK_GLASS, label: "Break Glass",       icon: BrickWallFire },
];

/**
 * IdentityLayout
 *
 * Persistent left-side nav for the /settings/identity/* sub-section.
 * Sub-pages render into the <Outlet />.
 */
const IdentityLayout = () => (
  <div className="flex w-full h-full">
    {/* Left nav — visible on md+ */}
    <div className="hidden md:flex flex-col w-52 flex-shrink-0 border-r border-edge-gray-200 dark:border-edge-dialog-border pt-5 pb-6 px-3 gap-1">
      <p className="text-[11px] font-semibold uppercase tracking-wider text-ink-gray-400 dark:text-ink-gray-500 px-3 mb-2">
        Identity
      </p>
      <SettingsSectionNav items={IDENTITY_NAV} />
    </div>

    {/* Main content */}
    <div className="flex-1 min-w-0 overflow-hidden">
      <Outlet />
    </div>
  </div>
);

/**
 * IdentityIndexRedirect
 *
 * /settings/identity with no sub-path → redirect to SSO (first tab).
 */
export const IdentityIndexRedirect = () => (
  <Navigate to={ROUTES.SETTINGS.IDENTITY_SSO} replace />
);

export default IdentityLayout;
